// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/main." + {"316":"d188cc53e496520e620d","675":"d6650430435631ee336d"}[chunkId] + ".css";
};